module.exports = __webpack_public_path__ + "img/J11785.aced8cee.png";